import { EmptyCell, type IColumn, Typography } from 'shared/ui'
import { DayjsFormats } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { type PersonalAccessTokenRow } from 'pages/settings/pages/developer/pages/accessTokens/model/PersonalAccessTokenRow'

export const accessTokensTableColumns: IColumn<PersonalAccessTokenRow>[] = [
  {
    field: 'name',
    name: 'Name',
    width: '240px',
    paddingHeader: '0 8px 0 12px',
    renderRowCell: (row) => (
      <Typography
        variant='body-md-regular'
        ariaLabel='PersonalAccessTokenName'
        tag='div'
        ellipsis
        width='100%'
        tooltipProps={{ label: row.name }}
      >
        {row.name || <EmptyCell />}
      </Typography>
    ),
  },
  {
    field: 'created_at',
    name: 'Issued on',
    width: '240px',
    renderRowCell: (row) => {
      const issuedAt = row.created_at && uiStore.dayjs(row.created_at).format(DayjsFormats.full6)
      if (!issuedAt) return <EmptyCell />
      return (
        <Typography
          variant='body-md-regular'
          ariaLabel='PersonalAccessTokenIssuedAt'
          tag='div'
          ellipsis
          tooltipProps={{ label: issuedAt }}
        >
          {issuedAt}
        </Typography>
      )
    },
  },
  {
    field: 'expires_at',
    name: 'Expires on',
    minWidth: 112,
    renderRowCell: (row) => {
      const expiresAt = row.expires_at && uiStore.dayjs(row.expires_at).format(DayjsFormats.full6)
      if (!expiresAt) return <EmptyCell />
      return (
        <Typography
          variant='body-md-regular'
          ariaLabel='PersonalAccessTokenExpiresAt'
          tag='div'
          ellipsis
          tooltipProps={{ label: expiresAt }}
        >
          {expiresAt}
        </Typography>
      )
    },
  },
]
